var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconAddBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.25h-4.5v-4.5a3 3 0 0 0-3-3h-1.5a3 3 0 0 0-3 3v4.5h-4.5a3 3 0 0 0-3 3v1.5a3 3 0 0 0 3 3h4.5v4.5a3 3 0 0 0 3 3h1.5a3 3 0 0 0 3-3v-4.5h4.5a3 3 0 0 0 3-3v-1.5a3 3 0 0 0-3-3Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconAddBold);
export default __webpack_public_path__ + "static/media/streamline-icon-add-bold.705b486c.svg";
export { ForwardRef as ReactComponent };